import React, { useContext, useState } from "react";

import { Typography, Col, Row, Drawer, message, Space, Button } from "antd";
const { Text } = Typography;

import { DownloadOutlined, PlusOutlined } from "@ant-design/icons";
import { CompaniesContext, EntitiesContext } from "../contexts";
import { WaitingForACompany } from "../components/WaitingForACompany";
import { CardSelectable, TableReport } from "../components/reports";

import PropTypes from "prop-types";
import { get_bank_transactions } from "../services";
import { currencyGetter } from "../utils/BankCurrencyUtils";
import { downloadXlsx } from "../components/banks/templatesConverter";
import { formatDateStampToString } from "../components/banks/utils";
import dayjs from "dayjs";
import { BankAccountsAllReport } from "../components/reports/BankAccountsAllReport";

// { token }
export const ReportsTransactions = ({ token }) => {
	const { selectedCompany: company } = useContext(CompaniesContext);
	const { clients, suppliers } = useContext(EntitiesContext);

	const [bankAccountReportSelected, setBankAccountReportSelected] = useState(null);
	const [openAdvancesPaidReport, setOpenAdvancesPaidReport] = useState(false);
	const [openAdvancesCollectedReport, setOpenAdvancesCollectedReport] = useState(false);
			
	const [dataToProcess, setDataToProcess] = useState([]);
	
	const [loading, setLoading] = useState(false);

	const fetchBankTransactionsForReport = async (position, setOpen = () => {}) => {
		setOpen(true);
		setLoading(true);
		setDataToProcess([]);

		const data = {
			company_id: company.id,
			type_of_transaction: position,
		};
		
		try {
			const response = await get_bank_transactions(token, "reports", data);
			// Convert the timestamp to string
			if(response){
				const dataFormated = response.map((data) => {
					return {
						...data,
						date: `${formatDateStampToString(data.date, 1)}`,
					};
				});
				
				setDataToProcess(dataFormated);
			}
		} catch (err) {
			message.error(err.response.data);
		} finally {
			setLoading(false);
		}
	};

	const loadMoreBankTransactions = async (position) => {		
		setLoading(true);

		const updateData = (newData) => {
			const amountNewBankTransactions = newData.length;
			
			if(amountNewBankTransactions === 0){
				message.info("No hay más transacciones bancarias que agregar");
				return;
			}
			
			message.info(`${amountNewBankTransactions} Transacciones Bancarias Agregadas`);
			setDataToProcess([...dataToProcess, ...newData]);
		};
		
		try {
			const lastInvoiceId = dataToProcess[dataToProcess.length - 1].id;
		
			const data = {
				company_id: company.id,
				type_of_transaction: position,
				last_element: lastInvoiceId,
			};

			const response = await get_bank_transactions(token, "reports", data);
			
			if(response){ // Convert the timestamp to string
				const dataFormated = response.map((data) => {
					return {
						...data,
						date: `${formatDateStampToString(data.date, 1)}`,
					};
				});
								
				updateData(dataFormated);
			}
		} catch (err) {
			message.error(err.response.data);
		} finally {
			setLoading(false);
		}
	};

	const showEntityName = (entityId, position) => {
		if(position === "in"){
			const clientsFounded = clients.filter((client) => client.id === entityId);
			const { name = "N/A" } = clientsFounded[0] ?? {};
			return name;
		}
		
		if(position === "out"){
			const suppliersFounded = suppliers.filter((client) => client.id === entityId);			
			const { name = "N/A" } = suppliersFounded[0] ?? {};
			return name;
		}
		
		return null;
	};
	
	const ReportsTransactionsView = (
		<>
			<Row gutter={16} style={{ marginTop: "7%", marginRight: "10%", marginLeft: "10%", justifyContent: "center" }}>
				<Col xs={24} sm={24} md={24}>
					<CardSelectable
						title="Reporte General de Transacciones"
						description="Reporte consolidado de todas las transacciones bancarias junto a las cuentas bancarias de esta compañía"
						onClick={() => setBankAccountReportSelected({ account_number: "ALL" })}
					/>
				</Col>
				<Col xs={24} sm={12} md={12} style={{ marginTop: "20px" }}>
					<CardSelectable
						title="Anticipos Pagados"
						description="Transacciones de débitos no consumidos o parcialmente consumidas."
						onClick={() => fetchBankTransactionsForReport("out", setOpenAdvancesPaidReport)}
					/>
				</Col>
				<Col xs={24} sm={12} md={12} style={{ marginTop: "20px" }}>
					<CardSelectable
						title="Anticipos Cobrados"
						description="Transacciones de créditos no consumidas o parcialmente consumidas."
						onClick={() => fetchBankTransactionsForReport("in", setOpenAdvancesCollectedReport)}
					/>
				</Col>
			</Row>
		</>
	);
	
	const columnsBankTransactions = [
		{
			title: "Fecha",
			dataIndex: "date",
			width: 50,										
			fixed: "left",
			align: "center",
			render: (value) => (
				<Text>{value}</Text>
			),
		},
		{
			title: "Banco",
			dataIndex: "bank_name",
			width: 50,										
			fixed: "left",
			align: "center",
			render: (value) => (
				<Text>{value}</Text>
			),
		},
		{
			title: "N. Cuenta Bancaria",
			dataIndex: "bank_account_number",
			width: 50,										
			fixed: "left",
			align: "center",
			render: (value) => (
				<Text>{value}</Text>
			),
		},
		{
			title: "Referencia",
			dataIndex: "transaction_number",
			width: 50,										
			fixed: "left",
			align: "center",
			render: (value) => (
				<Text>{value}</Text>
			),
		},
		{
			title: "Entidad",
			dataIndex: "entity_id",
			width: 150,										
			fixed: "left",
			align: "center",
			render: (value, record) => (
				<Text>{showEntityName(value, record.position)}</Text>
			),
		},
		{
			title: "Descripción",
			dataIndex: "description",
			width: 200,										
			fixed: "left",
			align: "center",
			render: (value) => (
				<Text>{value}</Text>
			),
		},
		{
			title: "Descripción",
			dataIndex: "note",
			width: 200,										
			fixed: "left",
			align: "center",
			render: (value) => (
				<Text>{value}</Text>
			),
		},
		{
			title: "Clasificación",
			dataIndex: "classification",
			width: 125,										
			fixed: "left",
			align: "center",
			render: (value) => (
				<Text>{value}</Text>
			),
		},		
		{
			title: "Monto",
			dataIndex: "amount",
			width: 50,										
			fixed: "left",
			align: "center",
			render: (value) => (
				<Text>{value}</Text>
			),
		},		
		{
			title: "Estado Cubierto",
			dataIndex: "reconciliation_not_payed",
			width: 70,										
			fixed: "left",
			align: "center",
			render: (value) => (
				<Text>{value ? "No Cubierto" : "Cubierto Parcialmente"}</Text>
			),
		},
		{
			title: "Cantidad Cubierta",
			dataIndex: "reconciliation_total",
			width: 60,										
			fixed: "left",
			align: "center",
			render: (value, record) => (				
				<Text>{`${currencyGetter[record?.currency]} ${value}`}</Text>
			),
		},		
	];

	const downloadFileXlsx = (positionConsult = "") => {
		if (dataToProcess.length === 0) {
			message.error("No hay data que descargar");
			return;
		}
	
		const headers = columnsBankTransactions.map(({ title }) => title);
		const dataMatrix = [headers];
		
		dataToProcess.forEach((item) => {
			const row = columnsBankTransactions.map(({ dataIndex, render }) => {
				if (render) {
					const valueRendered = render(item[dataIndex], item);
					return valueRendered?.props?.children ?? item[dataIndex] ?? "N/A";
				}
	
				return item[dataIndex] ?? "N/A";
			});
	
			dataMatrix.push(row);
		});
	
		const today = dayjs(new Date());
		const positionkind = positionConsult === "out" ? "Anticipos_Pagados" : "Anticipos_Cobrados";
		const nameFile = `_Reporte_Transacciones_${positionkind}_${today.format("YYYY-MM-DD_HH-mm-ss")}-Company_${company.name}-${company.tid}`;
	
		downloadXlsx(dataMatrix, nameFile);
	};

	const AllTransactionsReport = (
		<BankAccountsAllReport
			token={token}
			company={company}
			bankAccountReportSelected={bankAccountReportSelected}
			setBankAccountReportSelected={setBankAccountReportSelected}
		/>
	);
	
	const AdvancesPaid = (
		<Drawer
			title="Anticipos Pagados"
			placement="right"
			width={"100%"}
			open={openAdvancesPaidReport}
			onClose={() => setOpenAdvancesPaidReport(false)}
			extra={
				<Space>
					<Button
						type="primary"
						icon={<PlusOutlined />}
						loading={loading}
						disabled={dataToProcess.length === 0}
						onClick={() => loadMoreBankTransactions("out")}
					>Cargar Más Facturas</Button>
					<Button
						type="primary"
						icon={<DownloadOutlined />}
						loading={loading}
						onClick={() => downloadFileXlsx("out")}
					>Descargar Reporte</Button>
				</Space>
			}
		>
			<TableReport
				data={dataToProcess}
				columns={columnsBankTransactions}
				loading={loading}
			/>
		</Drawer>
	);

	const AdvancesCollected = (
		<Drawer
			title="Anticipos Cobrados"
			placement="right"
			width={"100%"}
			open={openAdvancesCollectedReport}
			onClose={() => setOpenAdvancesCollectedReport(false)}
			extra={
				<Space>
					<Button
						type="primary"
						icon={<PlusOutlined />}
						loading={loading}
						disabled={dataToProcess.length === 0}
						onClick={() => loadMoreBankTransactions("in")}
					>Cargar Más Facturas</Button>
					<Button
						type="primary"
						icon={<DownloadOutlined />}
						loading={loading}
						onClick={() => downloadFileXlsx("in")}
					>Descargar Reporte</Button>
				</Space>
			}
		>
			<TableReport
				data={dataToProcess}
				columns={columnsBankTransactions}
				loading={loading}
			/>
		</Drawer>
	);
	
	return (
		<>
			{/* Menu Select */}
			<WaitingForACompany company_id={company.id}/>
			{company.id !== "" && ReportsTransactionsView}

			{/* Drawers to Show */}
			{AllTransactionsReport}
			{AdvancesPaid}
			{AdvancesCollected}
		</>
	);
};

ReportsTransactions.propTypes = {
	token: PropTypes.string.isRequired,
};
